import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FeedbackService, FeedbackView } from './feedback.service';
import { CenteredLoadIndicatorComponent } from 'app/components/util/centered-load-indicator.component';
import { AggFeedbackViewComponent } from './agg/agg-feedback-view.component';
import { TanvoFeedbackViewComponent } from './tanvo/tanvo-feedback-view.component';
import { StaraFeedbackViewComponent } from './stara/stara-feedback-view.component';
import { DanceFeedbackViewComponent } from './dance/dance-feedback-view.component';
import { GflFeedbackViewComponent } from './gfl/gfl-feedback-view.component';

type FeedbackKind = 'stara' | 'tanvo' | 'dance' | 'gfl' | 'agg';

@Component({
  standalone: true,
  imports: [
    TranslateModule,
    CenteredLoadIndicatorComponent,
    AggFeedbackViewComponent,
    TanvoFeedbackViewComponent,
    StaraFeedbackViewComponent,
    DanceFeedbackViewComponent,
    GflFeedbackViewComponent,
  ],
  templateUrl: './view-feedback.component.html',
})
export class ViewFeedbackComponent implements OnInit {
  @Input() token: string;

  view: FeedbackView | null = null;
  loading = true;
  notFound = false;

  constructor(private feedbackService: FeedbackService) {}

  get feedbackKind(): FeedbackKind {
    if (this.view?.sportType === 'STARA') {
      return 'stara';
    }
    if (this.view?.sportType === 'DANCE_LUMO') {
      return 'dance';
    }
    if (this.view?.sportType === 'GFL') {
      return 'gfl';
    }
    return this.view?.sportType === 'TANVO' ? 'tanvo' : 'agg';
  }

  ngOnInit() {
    if (!this.token) {
      this.loading = false;
      this.notFound = true;
      return;
    }
    this.feedbackService.getFeedback(this.token).subscribe({
      next: (result) => {
        this.view = result;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.notFound = err.status === 404;
      },
    });
  }
}
